module.exports = __webpack_public_path__ + "img/logo.715d7648.svg";